import React from 'react';
import { Type } from '@spotify-internal/encore-creator-web';

import styles from '../index.module.scss';
import { GenderDemographicsChart } from '../../../../components/Shared/Charts/GenderDemographicsChart';
import { LoadingIndicator } from '../../../../components/Shared/LoadingIndicator';
import { GenderWithPercentage } from '../../../../types';
import { FormattedMessage } from 'react-intl';

type Props = {
  loading?: boolean;
  genderData: GenderWithPercentage[];
};

export function GenderChart(props: Props) {
  return (
    <div className={styles.wrapper} data-qa="episode-demographics-gender-chart">
      <Type as="h1" variant={Type.heading3}>
        <FormattedMessage id="episode.gender.title" defaultMessage="Gender" />
      </Type>
      {props.loading ? (
        <div style={{ width: '100%', height: '350px' }}>
          <LoadingIndicator />
        </div>
      ) : (
        <GenderDemographicsChart genderData={props.genderData} />
      )}
    </div>
  );
}
